module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<p class="group-title">' +
__e( name ) +
'</p>\n<div class="icons-container"></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/button/ButtonIconCollectionView.tpl
// module id = 1761
// module chunks = 0